// Centralizovaná konfigurace kontaktních údajů
export const CONTACT = {
  phone: '+420 792 771 480',
  phoneLink: 'tel:+420792771480',
  email: 'info@chalupalaura.cz',
  emailLink: 'mailto:info@chalupalaura.cz',
  address: 'Bublava 327, 358 01 Kraslice',
  bankAccount: '2101592745/2010',
  iban: 'CZ8820100000002101592745',
} as const;

export const SOCIAL = {
  // Přidat pokud budou sociální sítě
  // facebook: 'https://facebook.com/chalupalaura',
  // instagram: 'https://instagram.com/chalupalaura',
} as const;

export const SITE = {
  name: 'Chalupa Laura',
  url: 'https://chalupalaura.cz',
  description: 'Útulná horská chalupa v srdci Krušných hor, ideální pro rodiny a přátele.',
} as const;
